module.exports = __webpack_public_path__ + "static/ru-3-dfaf3cb5e6e173b3caded76d36065c8d.png";